import { render, staticRenderFns } from "./AzPersonsMetadataReadOnlyPanel.vue?vue&type=template&id=31df558d"
import script from "./AzPersonsMetadataReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./AzPersonsMetadataReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports